import { Id } from "components/kanbanBoard/types";

export enum ResourceType {
  GENERAL = "general",
  BUILDING = "building",
  UNIT = "unit",
  HELPDESK = "helpdesk",
  RENOVATION = "renovation",
  RENTAL_FILE = "rentalfile",
  CONTACT = "contact",
  COMPANY = "company",
  COMPANIES = "companies",
  TASK = "task",
  CONTRACT = "contract",
}

export type Resource = {
  id: Id;
  type: ResourceType;
  resourceId: string;
  name: string;
  metadata1: string;
  metadata2: string;
  sharePointFolderId: string;
  sharePointFolderUrl: string;
  sharePointPicturesFolderId: string;
  sharePointPicturesFolderUrl: string;
};
